import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

const BASE_URL = 'https://goleevo.com'
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`

function SEOHead({
  title,
  description,
  path = '/',
  type = 'website',
  image = DEFAULT_IMAGE,
  noindex = false,
  keywords = [],
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor = 'Leevo',
  articleSection,
  children
}) {
  const fullUrl = `${BASE_URL}${path}`
  const fullTitle = title.includes('Leevo') ? title : `${title} | Leevo`
  const keywordsString = keywords.length > 0 ? keywords.join(', ') : null

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {keywordsString && <meta name="keywords" content={keywordsString} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Leevo" />
      <meta property="og:locale" content="en_US" />

      {type === 'article' && articlePublishedTime && (
        <meta property="article:published_time" content={articlePublishedTime} />
      )}
      {type === 'article' && articleModifiedTime && (
        <meta property="article:modified_time" content={articleModifiedTime} />
      )}
      {type === 'article' && articleAuthor && <meta property="article:author" content={articleAuthor} />}
      {type === 'article' && articleSection && <meta property="article:section" content={articleSection} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {children}
    </Helmet>
  )
}

SEOHead.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  path: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.string,
  noindex: PropTypes.bool,
  keywords: PropTypes.arrayOf(PropTypes.string),
  articlePublishedTime: PropTypes.string,
  articleModifiedTime: PropTypes.string,
  articleAuthor: PropTypes.string,
  articleSection: PropTypes.string,
  children: PropTypes.node
}

export default SEOHead

